import React from 'react';
import Product from '../../components/Product';
import { useIntl } from 'react-intl';


const Advertising = () => {

    const textTranslator = useIntl();

    const data = {
        id: 44,
        id_en: 300,
        title: textTranslator.formatMessage({ id: 'home.products.bloc.products.title' }),
        class_img: 'advert'
    }

    return (
        <div>
            <Product data={data} />
        </div>
    );
};

export default Advertising;